import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, DEFAULTNFTIMAGE, NFTIMAGEBASEURL } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData } from '../helpers/Library';
import Loader from '../commons/Loader';
import axios from "axios";





const NonMintedNft = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [userBalance, setUserBalance] = useState(0);
    const [nfts,setNfts] = useState([])


    

    /* Method defination to fetch user balance */
    let getUserBalance = () => {
        let payload = { "uuid": getAllSessionData().uuid }
        setShowLoader(true)
        callAPI('post', NFTAPIBASENAME + '/transaction/getUserBalance', payload, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                let userBalanceList = response.userBalanceList
                for (let i = 0; i < userBalanceList.length; i++) {
                    if (userBalanceList[i].currencyId == 3) {
                        setUserBalance(userBalanceList[i].closingBalance)
                    }
                }

            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    /* Get unminted nfts list */
    let getUnMintedNfts = () =>{
        let payload = { "userUuid": getAllSessionData().uuid ,"pageNo":"1","pageSize":"50"}
        setShowLoader(true)
        callAPI('post', NFTAPIBASENAME + '/nft/market/getNonmintedNftsByUser', payload, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                setNfts(response.nfts);

            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }
    /* Get unminted nfts list */
    let handleReMintNft = (id) =>{
        let payload = { "userUuid": getAllSessionData().uuid ,entityId:id}
        setShowLoader(true)
        callAPI('post', NFTAPIBASENAME + '/nft/market/remintNft', payload, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                showToast('success', 'NFT re-minted successfully')
                getUnMintedNfts();

            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        if (!checkIfUserIsLoggedIn()) {
            showToast('error', 'Please login to continue',);
            setTimeout(() => {
                props.history.push("/");
            }, 1000);
        } else {
            getUserBalance();
            getUnMintedNfts();
           
        }
    }, []);

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h3>Non Minted NFT</h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                        <table className="table table-hover table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" width="40%">Nft</th>
                                        <th scope="col" width="10%">Price</th>
                                        <th scope="col" width="20%">Description</th>
                                        <th scope="col" width="20%">Created On</th>
                                        <th scope="col" width="10%">Action</th>
                                    </tr>
                                </thead>
                                {nfts == null && <tbody>
                                    <tr>
                                        <td colSpan={5} className='text-center'>NO DATA</td>
                                    </tr>
                                </tbody>}
                                 {nfts != null && <tbody>
                                    {nfts.map((nft) => ( <tr>
                                        <td width="40%">
                                            <div className="row">
                                                <img className="col-md-4" src={NFTIMAGEBASEURL + '/' + nft.nftFileName}alt="" height="50px" width="20px" />
                                                <span><Link to={`/asset/${nft.nftId}`}>{nft.nftName}</Link></span>
                                            </div>
                                        </td>
                                        <td width="10%">{nft.nftPrice} ETH</td>
                                        <td width="20%">{nft.nftDescription}</td>
                                        <td width="20%">{nft.createdOn}</td>
                                        <td width="10%">
                                            <button className="btn btn-primary" onClick={()=>{
                                                handleReMintNft(nft.nftId)
                                            }}>Re-Mint</button>
                                        </td>
                                    </tr>))}
                                   

                                </tbody>} 
                            </table>
                        </div>
                    </div>
                   
                </div>
            </div>










            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default NonMintedNft;